import { homepage as HOME_URL } from "../../../config";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import AddChartIcon from "@mui/icons-material/Addchart";

function AppLogo() {
    return (
        <Link component={RouterLink} to={HOME_URL} color="text.primary" sx={{ textDecoration: "none" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 0.4,
                    width: "100%",
                    height: "100%",
                    paddingX: ".5em",
                }}
            >
                <Typography variant="h6" fontWeight="bold">
                    SODD
                </Typography>
                <AddChartIcon fontSize="small" />
            </Box>
        </Link>
    );
}

export default AppLogo;
